// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Ticket$ReactHooksTemplate = require("./ticket.res.js");
var TicketCategory$ReactHooksTemplate = require("./ticketCategory.res.js");

var intialState = {
  feedbackTab: false
};

function TicketHistoryView(props) {
  var ticket_history = props.ticket_history;
  var match = React.useState(function (param) {
        return intialState;
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = Ticket$ReactHooksTemplate.status(ticket_history);
  var match$2;
  switch (match$1) {
    case "Open" :
        match$2 = [
          Image$ReactHooksTemplate.workOnTickets,
          "bg-green-50 border-green-200",
          "Open",
          "text-green-700"
        ];
        break;
    case "Parked" :
        match$2 = [
          Image$ReactHooksTemplate.clockCircle,
          "bg-yellow-50 border-yellow-200",
          "Parked",
          "text-yellow-700"
        ];
        break;
    case "Closed" :
        match$2 = [
          Image$ReactHooksTemplate.submit,
          "bg-gray-50 border-gray-200",
          "Closed",
          "text-gray-700"
        ];
        break;
    case "Resolved" :
        match$2 = [
          Image$ReactHooksTemplate.submit,
          "bg-green-50 border-green-200",
          "Resolved",
          "text-green-700"
        ];
        break;
    
  }
  var tmp;
  if (state.feedbackTab) {
    var response = Ticket$ReactHooksTemplate.normalResponses(ticket_history);
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {
          children: Caml_option.some(JsxRuntime.jsx("div", {
                    children: response !== undefined ? JsxRuntime.jsx("div", {
                            children: Belt_Array.mapWithIndex(response.header, (function (i, h) {
                                    return JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("div", {
                                                                children: JsxRuntime.jsx("span", {
                                                                      children: "Q",
                                                                      className: "text-white text-xs font-bold"
                                                                    }),
                                                                className: "flex-shrink-0 w-5 h-5 rounded-full bg-blue-500 flex items-center justify-center"
                                                              }),
                                                          JsxRuntime.jsx("div", {
                                                                children: h,
                                                                className: "flex-1 text-xs font-medium text-gray-900 leading-relaxed"
                                                              })
                                                        ],
                                                        className: "bg-blue-50 border-b border-blue-100 p-2 flex items-start gap-2"
                                                      }),
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("div", {
                                                                children: JsxRuntime.jsx("span", {
                                                                      children: "A",
                                                                      className: "text-white text-xs font-bold"
                                                                    }),
                                                                className: "flex-shrink-0 w-5 h-5 rounded-full bg-green-500 flex items-center justify-center"
                                                              }),
                                                          JsxRuntime.jsx("div", {
                                                                children: Belt_Option.getWithDefault(Caml_array.get(response.contents, i), "No response provided"),
                                                                className: "flex-1 text-xs text-gray-700 leading-relaxed break-words"
                                                              })
                                                        ],
                                                        className: "bg-white p-2 flex items-start gap-2"
                                                      })
                                                ],
                                                className: "bg-white rounded-lg border border-gray-200 overflow-hidden"
                                              }, h);
                                  })),
                            className: "space-y-2"
                          }) : JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("p", {
                                  children: "No feedback available",
                                  className: "text-xs text-gray-500 italic"
                                }),
                            className: "text-center py-4"
                          }),
                    className: "overflow-auto max-h-60 p-2"
                  }))
        });
  } else {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "h-3.5 w-3.5",
                                            src: match$2[0]
                                          }),
                                      className: "flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center border " + match$2[1]
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("span", {
                                                      children: "#" + String(Ticket$ReactHooksTemplate.id(ticket_history)),
                                                      className: "text-sm font-semibold text-gray-900"
                                                    }),
                                                JsxRuntime.jsx("span", {
                                                      children: match$2[2],
                                                      className: "text-xs font-semibold " + match$2[3]
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: TicketCategory$ReactHooksTemplate.name(Ticket$ReactHooksTemplate.ticketCategory(ticket_history)),
                                                      className: "inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium text-white",
                                                      style: {
                                                        backgroundColor: TicketCategory$ReactHooksTemplate.colorToString(TicketCategory$ReactHooksTemplate.color(Ticket$ReactHooksTemplate.ticketCategory(ticket_history)))
                                                      }
                                                    })
                                              ],
                                              className: "flex items-center gap-2 flex-wrap"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      className: "h-3 w-3 mr-1",
                                                      src: Image$ReactHooksTemplate.clockCircle
                                                    }),
                                                JsxRuntime.jsx("span", {
                                                      children: Ticket$ReactHooksTemplate.createdAt(ticket_history).format("MMM DD, h:mm A")
                                                    })
                                              ],
                                              className: "flex items-center text-xs text-gray-500 mt-0.5"
                                            })
                                      ],
                                      className: "flex-1 min-w-0"
                                    })
                              ],
                              className: "flex items-center gap-2 flex-1 min-w-0"
                            }),
                        JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "h-3 w-3",
                                          src: Image$ReactHooksTemplate.chevronDown
                                        }),
                                    className: "transition-transform duration-200 " + (
                                      state.feedbackTab ? "rotate-180" : ""
                                    )
                                  }),
                              className: "text-gray-500 hover:text-gray-700 transition-colors flex-shrink-0",
                              onClick: (function (param) {
                                  Curry._1(setState, (function (state) {
                                          return {
                                                  feedbackTab: !state.feedbackTab
                                                };
                                        }));
                                })
                            })
                      ],
                      className: "flex items-center justify-between p-2 border-b border-gray-200 bg-gray-50"
                    }),
                tmp
              ],
              className: "bg-white rounded-lg border border-gray-200 overflow-hidden"
            });
}

var make = TicketHistoryView;

exports.intialState = intialState;
exports.make = make;
/* react Not a pure module */
